import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: { text: string }) => {
  return httpRequest.post("/erp/back_office/item_reference/tag", data);
};

export const select = async () => {
  return httpRequest.get("/erp/back_office/item_reference/tag/select");
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/erp/back_office/item_reference/tag", { offset, filter });
};

export const update = async (id: string, data: { text: string }) => {
  return httpRequest.put(`/erp/back_office/item_reference/tag/${id}`, data);
};

export const remove = async (id: string) => {
  return httpRequest.del(`/erp/back_office/item_reference/tag/${id}`);
};
